import WardrobesSvg from "@assets/images/svg/wardrobes.svg";
import React from "react";
import { View } from "react-native";

export interface WardrobesIconProps {
  size?: number;
  color?: string;
}

export function WardrobesIcon({
  size = 24,
  color = "#4D4D4D",
}: WardrobesIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <WardrobesSvg width={size} height={size} color={color} />
    </View>
  );
}

export default WardrobesIcon;
